import React, { type FunctionComponent } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Popover } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import { useAppMessaging } from '../../../hooks/useAppMessaging';
import BreakoutRoomOptionsContainer from '../BreakoutRoomOptionsContainer';
import { StyledButtonContainer, StyledButtonGroup, StyledSubMenuContainer, StyledSubButtonGroup } from '../styles/styled-components';

interface BreakoutRoomRowProps {
    roomId: string;
    roomName: string;
}

const DeleteRoom: FunctionComponent<BreakoutRoomRowProps> = ({ roomId, roomName }) => {
    const { t } = useTranslation('breakout_room');
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const { roomsOpen } = useContainer(BreakoutRoomOptionsContainer);
    const { sendMessage } = useAppMessaging();

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (event) => {
        event.stopPropagation();
        setAnchorEl(null);
    };

    const handleDelete = (event) => {
        handleClose(event);

        sendMessage({
            payload: { func: 'remove_breakout_room', room_id: roomId }
        });
    };

    const open = Boolean(anchorEl);

    return (
        <StyledButtonContainer>
            <StyledButtonGroup>
                <Button aria-describedby={t('delete')} variant="outlined" startIcon={<DeleteIcon />} onClick={handleClick} disabled={roomsOpen} size="small">
                    {t('Delete')}
                </Button>
                <Popover
                    id={t('delete-popup')}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center'
                    }}
                >
                    <StyledSubMenuContainer>
                        {t('Delete')} {roomName}?
                    </StyledSubMenuContainer>
                    <StyledSubButtonGroup>
                        <Button aria-describedby={t('delete')} variant="contained" onClick={handleDelete} style={{ margin: '5px' }}>{t('Delete')}</Button>
                        <Button aria-describedby={t('cancel')} variant="outlined" onClick={handleClose} style={{ margin: '5px' }}>{t('Cancel')}</Button>
                    </StyledSubButtonGroup>
                </Popover>
            </StyledButtonGroup>
        </StyledButtonContainer>
    );
};

export default DeleteRoom;
